import { Component, OnInit, Injector } from '@angular/core';
import { AuthenticationService } from '../../../../../auth.service';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { AuthorizationService } from '../../../ve.service';

@Component({
  selector: 'work-order-search-keyword-form',
  templateUrl: './work-order-search-keyword-form.component.html',
  styleUrls: ['./work-order-search-keyword-form.component.scss']
})
export class WorkOrderSearchKeywordFormComponent implements OnInit {
  editForm: any;
  formBuilder: UntypedFormBuilder;
  authService: AuthenticationService;
  authzService: AuthorizationService;

  constructor(injector: Injector) {
    this.authzService = injector.get(AuthorizationService);
    this.authService = injector.get(AuthenticationService);
    this.formBuilder = injector.get(UntypedFormBuilder);
    this.editForm = this.formBuilder.group({
      TextSearch: []
    });
  }

  ngOnInit() {
    //this is kept empty on purpose
  }

}
